import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  // expose coursesEnrolled so the template can bind to it
  public coursesEnrolled: number = 6;
  public upcomingEvents: number = 0;
  public progressPercent: number = 0;
  public applicationsCount: number = 1;

  constructor(
    private afs: AngularFirestore
  ) { 
   
  }

  getUser(userId){
    return this.afs.collection('users').doc(userId).valueChanges();
  }
}
